/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-21 17:42:24
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 13:28:18
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/ReviewCard/Content/Channels/index.tsx
 */
import { SectionCollapse } from '@/src/components/Antd';
import { CircleTags } from '@/src/components/Antd/Tag/Tag';
import { Icon } from '@/src/tools/icon';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EnumCollapseArrowMode } from 'src/types/common/common';
import css from './css.module.less';

const Channels = (props) => {
  const { locales = [], uuid, name, onChange } = props;
  const isSingle = locales.length < 2;
  const handleOnChange = (body) => {
    const re = { ...(body || {}), salesChannelUuid: uuid };
    if (onChange) onChange(re);
  };
  const generator = () => {
    if (isSingle) {
      return locales.map((locale, index) => {
        const { top, publish, locale: _locale } = locale;
        return (
          <SingleLocaleChannel
            onChange={handleOnChange}
            key={index}
            publish={publish}
            uuid={uuid}
            top={top}
            name={name}
            locale={_locale}
          />
        );
      });
    } else {
      return (
        <MultiLocalesChannel
          onChange={handleOnChange}
          name={name}
          uuid={uuid}
          locales={locales}
        />
      );
    }
  };
  return <React.Fragment>{generator()}</React.Fragment>;
};

export default Channels;

const SingleLocaleChannel = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    name,
    top,
    publish,
    //uuid,
    containerClassName,
    isPrimary,
    onChange,
    locale,
    // onSetTop,
    // onSetPublish,
  } = props;

  const handleOnTopChange = () => {
    if (onChange) onChange({ top: !top, locale });
  };
  const handleOnPubChange = () => {
    if (onChange) onChange({ publish: !publish, locale });
  };
  return (
    <div className={`${css.singleContainer} ${containerClassName}`}>
      <div className={css.frontPartContainer}>
        <div className={css.statusIcon}>
          {publish ? (
            <CircleTags color='success'>
              {getI18n(
                'reviews.productreview.productReviewDetail_ReviewCard_content_channels_Published',
              )}
            </CircleTags>
          ) : (
            <CircleTags color='warning'>
              {getI18n(
                'reviews.productreview.productReviewDetail_ReviewCard_content_channels_Unpublished',
              )}
            </CircleTags>
          )}
        </div>
        <div className={css.name}>
          {name}
          {isPrimary ? getI18n('general.primary') : ''}
        </div>
      </div>
      <Backs
        top={top}
        publish={publish}
        onSetTop={handleOnTopChange}
        onSetPublish={handleOnPubChange}
      />
    </div>
  );
};

const MultiLocalesChannel = (props) => {
  const { onChange, name, uuid, locales = [], onSetTop, onSetPublish } = props;
  const generateItems = () => {
    return locales.map((l, index) => {
      const { top, publish, isPrimary, locale } = l;
      return (
        <div className={css.multiContainer} key={`${uuid}${locale}`}>
          <SingleLocaleChannel
            onChange={onChange}
            uuid={uuid}
            name={locale}
            locale={locale}
            isPrimary={isPrimary}
            top={top}
            publish={publish}
            onSetTop={onSetTop}
            onSetPublish={onSetPublish}
          />
        </div>
      );
    });
  };
  return (
    <SectionCollapse
      arrayPosition={EnumCollapseArrowMode.front}
      key={uuid}
      id={uuid}
      //titleStyle={i.style}
      title={name}
      content={generateItems()}
      openMargin={0}
      onClickTrigger={(e) => {
        return e;
      }}
    />
  );
};

const Backs = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { onSetTop, onSetPublish, top, publish } = props;
  return (
    <div className={css.backsContainer}>
      <div className={css.iconContainer}>
        <Icon
          type='icontop'
          className={`${css.topIcon} ${top ? css.selectedIcon : ''}`}
          onClick={onSetTop}
        />
      </div>
      <div className={css.publishContainer} onClick={onSetPublish}>
        {publish ? (
          <div className={css.unpublish}>
            {getI18n(
              'reviews.productreview.productReviewDetail_ReviewCard_content_channels_Unpublished',
            )}
          </div>
        ) : (
          <div className={css.publish}>
            {getI18n(
              'reviews.productreview.productReviewDetail_ReviewCard_content_channels_Published',
            )}
          </div>
        )}
      </div>
    </div>
  );
};
